import moment from "moment";

export default (value, unit = "seconds") => {
  const sign = value < 0 ? "" : "+";
  const duration = moment.duration(value, unit);
  const hours = duration.hours();
  const minutes = Math.abs(duration.minutes() % 60);

  return `${sign}${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
};
